import KaoguanPicker from './KaoguanPicker.vue'
export default KaoguanPicker